import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "gfu-sticky-table__header"
}
const _hoisted_2 = { class: "_contents" }
const _hoisted_3 = {
  key: 1,
  class: "gfu-sticky-table__body"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("table", {
    style: _normalizeStyle(`--columns: ${$props.columnsCount}`),
    class: _normalizeClass(['gfu-sticky-table', 'gfu-sticky-table--columns', $options.columnsGridClassName])
  }, [
    (_ctx.$slots['head'])
      ? (_openBlock(), _createElementBlock("thead", _hoisted_1, [
          _createElementVNode("tr", _hoisted_2, [
            _renderSlot(_ctx.$slots, "head")
          ])
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.$slots['body'])
      ? (_openBlock(), _createElementBlock("tbody", _hoisted_3, [
          _renderSlot(_ctx.$slots, "body")
        ]))
      : _createCommentVNode("v-if", true)
  ], 6 /* CLASS, STYLE */))
}